import { twMerge, ClassNameValue } from "tailwind-merge";

export function classNames(...classes: ClassNameValue[]) {
  return twMerge(...classes);
}
